export const SCHEMA_VERSION = 3;
//# sourceMappingURL=schema-version.js.map